export const currencyValueDivider = 10_000;
